import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const TENANTS_PATH = '/api/Tenant';

// Grid
export const getTenantsGrid = (params) => makeRequest(authFetch.get(`${TENANTS_PATH}${getQueryParams(params)}`));

export const saveTenant = (data) => makeRequest(authFetch.put(TENANTS_PATH, data));

export const deleteTenantById = (tenantId) => makeRequest(authFetch.delete(`${TENANTS_PATH}/${tenantId}`));

export const restoreTenantById = (tenantId) => makeRequest(authFetch.patch(`${TENANTS_PATH}/${tenantId}/restore`));

// Audit
export const getTenantAudits = (id, params) => makeRequest(
  authFetch.get(`${TENANTS_PATH}/${id}/Audits${getQueryParams(params)}`),
);

export const getTenantAuditProperties = (id) => makeRequest(
  authFetch.get(`${TENANTS_PATH}/${id}/Audits/Properties`),
);

export const getTenantAuditUsers = (id) => makeRequest(authFetch.get(`${TENANTS_PATH}/${id}/Audits/Users`));

// Lookup
export const getTenantsLookup = (params) => makeRequest(authFetch.get(`${TENANTS_PATH}/Lookup${getQueryParams(params)}`));
export const useGetTenants = (opts = {}) => useQuery(['tenants'], () => getTenantsLookup(), { ...CacheConfig.forever, ...opts });
